import './toolbar.scss';

import { Button, ButtonGroup } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { forEach } from 'lodash';

import { SaveIcon } from '../../../../assets/icons';
import { generateUuid } from '../../../../lib/utils/qol';
import { displayActions } from '../../../../store/slices/display';

const GraphiQLToolbar = ({ prettify, merge, copy, toggleHistory }) => {
  const dispatch = useDispatch();

  const requestHeaders = useSelector(({ workspace }) => workspace.requestHeaders);
  const numHeaders = useMemo(() => {
    const distinctHeaders = new Set();
    forEach(requestHeaders, header => {
      if(header.enabled) {
        distinctHeaders.add(header.name);
      }
    });
    return distinctHeaders.size;
  }, [requestHeaders]);

  const toggleWorkspaceSidebar = () => dispatch(displayActions.TOGGLE_WORKSPACE_SIDEBAR());
  const toggleSaveQueryDialog = () => dispatch(displayActions.TOGGLE_SAVE_QUERY_DIALOG());
  const toggleRequestHeaders = () => dispatch(displayActions.TOGGLE_MANAGE_REQUEST_HEADERS_DIALOG());
  const toggleRsaSignaturePieces = () => dispatch(displayActions.TOGGLE_MANAGE_RSA_SIGNATURE_DIALOG());

  return (
    <div id='editor_toolbar' className='editor_toolbar'>
      <Button
        variant='contained'
        color='primary'
        onClick={prettify}
        title='Prettify Query (Shift-Ctrl-P)'
        aria-label='Prettify'
        size='small'
      >
        Prettify
      </Button>

      <Button
        variant='contained'
        color='primary'
        onClick={merge}
        title='Merge Query (Shift-Ctrl-M)'
        aria-label='Merge'
        size='small'
      >
        Merge
      </Button>

      <Button
        variant='contained'
        color='primary'
        onClick={copy}
        title='Copy Query (Shift-Ctrl-C)'
        aria-label='Copy'
        size='small'
      >
        Copy
      </Button>

      <Button
        variant='contained'
        color='primary'
        onClick={generateUuid}
        title='Generate UUID'
        aria-label='UUID'
        size='small'
      >
        UUID
      </Button>

      <Button
        variant='contained'
        color='primary'
        onClick={toggleHistory}
        title='Show History'
        aria-label='Show History'
        size='small'
      >
        History
      </Button>

      <Button
        variant='contained'
        color='primary'
        onClick={toggleRequestHeaders}
        title='Manage Request Headers'
        aria-label='Manage Request Headers'
        size='small'
      >
        <span className="header-label">Headers</span>
        <span className="header-count">({numHeaders})</span>
      </Button>

      <Button
        variant='contained'
        color='primary'
        onClick={toggleRsaSignaturePieces}
        title='Manage RSA Signature'
        aria-label='Manage RSA Signature'
        size='small'
      >
        <span className="header-label">Signature</span>
      </Button>

      <ButtonGroup variant='contained' color='primary' aria-label='split button'>
        <Button
          color='primary'
          onClick={toggleWorkspaceSidebar}
          title='Show Workspace'
          aria-label='Show Workspace '
          size='small'
        >
          Collection
        </Button>
        <Button
          color='primary'
          size='small'
          aria-label='Add to collection'
          onClick={toggleSaveQueryDialog}
        >
          <SaveIcon />
        </Button>
      </ButtonGroup>
    </div>
  );
};

GraphiQLToolbar.propTypes = {
  prettify: PropTypes.func.isRequired,
  merge: PropTypes.func.isRequired,
  copy: PropTypes.func.isRequired,
  toggleHistory: PropTypes.func.isRequired,
};

export default memo(GraphiQLToolbar);
